import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';

import { CustomerPortalService }           from './customer-portal.service';
import { CustomerPortalSettingsComponent } from './customer-portal.settings.component';
import { CustomerPortalStates }            from './customer-portal.states';

@NgModule({
  declarations: [
    CustomerPortalSettingsComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    UIRouterModule.forChild({ states: CustomerPortalStates })
  ],
  providers: [
    CustomerPortalService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class CustomerPortalModule {}
